<template>
  <div class="contentBox">
    <h4 class="title">
      {{itemTitle}}
    </h4>
    <div class="line"></div>
    <el-form ref="form" :model="form" label-width="80px" style="margin:30px 0 10px;">
        <el-input v-model="form.id"  v-if="showfield"></el-input>
        <el-form-item label="索引名称" label-width="70px" style="display:inline-block">
          <el-input v-model="form.name" placeholder="请输入索引名称" :readonly="ifEdit"></el-input>
        </el-form-item>
        <el-form-item label="索引说明" label-width="70px" style="display:inline-block">
          <el-input v-model="form.remark" placeholder="请输入索引说明" :readonly="ifEdit"></el-input>
        </el-form-item>
        <button class="addBtn" @click="saveEdit">确定</button>
    </el-form>

    <h5 class="tableTitle"><img src="@/assets/images/icon27.png" alt=""> 索引对象</h5>
    <div class="btnBox">
      <button class="addBtn"  v-if="ifShow" @click="adddDialog">新增</button>
    </div>
   <!-- <li v-for="item in tableData" :key="item.tab" class="clearfix">
      <div class="indHeader">
        <div class="clearfix">
          <span>{{item.tabshow}}</span>
          <span>{{item.file1}}</span>
          <span>{{item.file2}}</span>
          <span>{{item.file3}}</span>
          <span>{{item.file4}}</span>
          <span>{{item.file5}}</span>
          <span>{{item.file6}}</span>
          <div class="iconBox">
            <span class="indInfo" @click="openCreatePage(2,item)">索引详情</span>
            <span>|</span>
            <span class="indInfo" @click="openCreatePage(3,item)">索引编辑</span>
            <span>|</span>
            <span class="indInfo" @click="deleteRowMap(item, 3)">索引删除</span>
          </div>
        </div>
      </div>
    </li> -->
    <el-table
      :data="tableData"
      style="width: 100%;"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="tabshow"
        label="表名"
        width="220">
      </el-table-column>
      <el-table-column
        prop="tab"
        label="物理表名"
        width="120" v-if="showfield">
      </el-table-column>
      <el-table-column
        prop="file1"
        label="字段">
      </el-table-column>
      <el-table-column
        prop="file2"
        label="">
      </el-table-column>
      <el-table-column
        prop="file3"
        label="">
      </el-table-column>
      <el-table-column
        prop="file4"
        label="">
      </el-table-column>
      <el-table-column
        prop="file5"
        label="">
      </el-table-column>
      <el-table-column
        prop="file6"
        label="">
      </el-table-column>
      <el-table-column
        prop="label"
        label="" v-if="showfield">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="200">
        <template slot-scope="scope">
          <el-button @click="editDialog(scope.$index,scope.row)" v-if="ifShow" type="text" size="small" class="editBtn">编辑</el-button>
          <el-button type="text" size="small" v-if="ifShow" @click="handleDelete(scope.$index)" class="delBtn">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="bottomBtnBox">
      <button class="sureBtn" v-if="ifShow" @click="diaRecreate = true">重建索引</button>
      <button class="backBtn" @click="backToPersonal">返回</button>
    </div>

  <el-dialog
      :title="提示"
      :visible.sync="diaRecreate"
      id="diaRecreate"
      width="30%">
      <p style="padding:20px">重建索引需要删除原有索引并重新导入全部数据重建，确认是否重建索引？</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createIndex" class="blueBtn">确定</el-button>
        <el-button @click="diaRecreate = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="65%">
      <div class="clearfix">
        <ul class="dataListUl">
          <div class="dataListTitle">
            <img src="@/assets/images/icon49.png" alt="">
            <span>数据表选择</span>
          </div>
          <li v-for="(item,index) in dataListUls" :key="item.value" @click="chooseData(index)"  :class="{'liActive':item.ifActive}">{{item.name}}</li>
        </ul>
        <div class="dataListBox">
          <div class="dataBoxTitle">
            <img src="@/assets/images/icon50.png" alt="">
            <span>{{tablename.name}} 选择索引字段</span>
          </div>
          <!-- <p>选择索引字段</p> -->
          <ul class="indLists clearfix">
            <div class="specilBox" v-if="tableDataAdd.length > 0">
              <h4>{{spectialFieldName}}</h4>
              <p>{{spectialField}}</p>
            </div>
            <li v-for="item in tableDataAdd" :key="item.value">
              <h4>{{item.metaName}}</h4>
              <p style="color:#4da1ff">数据示例：</p>
              <p :title="item.dataAll0">{{item.data0}}</p>
              <p :title="item.dataAll1">{{item.data1}}</p>
              <p :title="item.dataAll2">{{item.data2}}</p>
              <ul class="iconBtnBox">
                <!-- <li class="iconFlex"><img src="@/assets/images/icon27.png" alt="" title="名字"></li>
                <li class="iconFlex"><img src="@/assets/images/icon27.png" alt="" title="索引"></li>
                <li class="iconFlex"><img src="@/assets/images/icon27.png" alt="" title="分词"></li> -->
                <li class="iconFlex" @click="changeParticiple(item)" :style="{'color':item.isParticiple?'#ccc':'#4da1ff'}">
                  <img src="@/assets/images/icon51-1.png" alt="" title="分词" v-if="item.isParticiple">
                  <img src="@/assets/images/icon51.png" alt="" title="分词" v-else>
                </li>
                <li class="iconFlex" @click="changeIndex(item)" :style="{'color':item.isIndex?'#ccc':'#4da1ff'}">
                  <img src="@/assets/images/icon52-1.png" alt="" title="索引" v-if="item.isIndex">
                  <img src="@/assets/images/icon52.png" alt="" title="索引" v-else>
                </li>
                <li class="iconFlex" @click="changeStatus(item)" :style="{'color':item.isGray?'#ccc':'#4da1ff'}">
                  <img src="@/assets/images/icon53-1.png" alt="" title="名称" style="width:10px" v-if="item.isGray">
                  <img src="@/assets/images/icon53.png" alt="" title="名称" style="width:10px" v-else>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleAddrow" class="blueBtn">保存</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import common from './../../../public/arcgisjs/common.js';
import {Loading} from 'element-ui';
// 导入esri-loader（地图渲染）
// import esriLoader from "esri-loader";
// import { loadCss } from "esri-loader";
import request from '@/utils/request'
export default {
  name: 'createIndex',
  data(){
    return {
      diaRecreate:false,
      templateRadio:'',
      loading:true,
      loginusername:'',
      opstatus:'add',
      ifShow:false,
      ifEdit:false,
      itemTitle:'索引',
      title:'新增',
      cols: [],
      tables:[],
      fileds:[],
      selectfileds:[],
      selectparticiples:[],
      tabfile:[],
      tablename:'',
      selectedList:[], // 存储每次 option 选中的 集合
      modifyDialog:false,
      dialogVisible:false,
      form:{
        id:'',
        name:'',
        remark:''
      },
      tableData:[
        // {tab:"空间表名1",tabshow:"空间表名1",file1:"索引字段1",file2:"索引字段1",file3:"索引字段1",file4:"索引字段1",file5:"索引字段1",file6:"索引字段1"},
        // {tab:"空间表名1",tabshow:"空间表名1",file1:"索引字段1",file2:"索引字段1",file3:"索引字段1",file4:"索引字段1",file5:"索引字段1",file6:"索引字段1"},
        // {tab:"空间表名1",tabshow:"空间表名1",file1:"索引字段1",file2:"索引字段1",file3:"索引字段1",file4:"索引字段1",file5:"索引字段1",file6:"索引字段1"},
        // {tab:"空间表名1",tabshow:"空间表名1",file1:"索引字段1",file2:"索引字段1",file3:"索引字段1",file4:"索引字段1",file5:"索引字段1",file6:"索引字段1"},
        // {tab:"空间表名1",tabshow:"空间表名1",file1:"索引字段1",file2:"索引字段1",file3:"索引字段1",file4:"索引字段1",file5:"索引字段1",file6:"索引字段1"},
        // {tab:"空间表名1",tabshow:"空间表名1",file1:"索引字段1",file2:"索引字段1",file3:"索引字段1",file4:"索引字段1",file5:"索引字段1",file6:"索引字段1"},
        // {tab:"空间表名1",tabshow:"空间表名1",file1:"索引字段1",file2:"索引字段1",file3:"索引字段1",file4:"索引字段1",file5:"索引字段1",file6:"索引字段1"},
        // {tab:"空间表名1",tabshow:"空间表名1",file1:"索引字段1",file2:"索引字段1",file3:"索引字段1",file4:"索引字段1",file5:"索引字段1",file6:"索引字段1"},
        // {tab:"空间表名1",tabshow:"空间表名1",file1:"索引字段1",file2:"索引字段1",file3:"索引字段1",file4:"索引字段1",file5:"索引字段1",file6:"索引字段1"}
      ],
      tableDataAdd:[],
      dataListUls:[],
      showfield:false,
      tableRadio:'',
      templateSelection:[],
      spectialField:'',
      spectialFieldName:'',
      editindex:''
    }
  },
  props:{
    clickBtnObj:Object
  },
  created(){
    // console.log(this.clickBtnObj)
    if(this.clickBtnObj.ind == 1){
      //创建索引页面
      this.itemTitle = '创建索引'
      this.ifShow = true
      this.ifEdit = false
    }else if(this.clickBtnObj.ind == 2){
      //索引详情页面
      this.itemTitle = '索引详情'
      this.ifShow = false
      this.ifEdit = true
      this.form = Object.assign({},this.clickBtnObj.val)
      var indexid=this.clickBtnObj.val
      this.form.id=this.clickBtnObj.val
      this.getTableData(indexid)
    }else{
      //索引编辑页面
      this.itemTitle = '索引编辑'
      this.ifShow = true
      this.ifEdit = false
      this.form = Object.assign({},this.clickBtnObj.val)
      var indexid=this.clickBtnObj.val
      this.form.id=this.clickBtnObj.val
      this.getTableData(indexid)
    }
    this.loginusername=JSON.parse(localStorage.getItem('portalUserName'))
    this.getTableList()
  },
  methods:{
    //确定修改
    saveEdit(){

    },
    //更改文字颜色
    changeStatus(val){     
      this.tableDataAdd.forEach((v,i) => {
        if(val.metaName == v.metaName){
          v.isGray = true
        }else{
          v.isGray = false//!v.isGray
        }
        // console.log("v.isGray="+v.isGray)
      })
      if(val.isGray)this.tableRadio=val
      else this.tableRadio=''
    },
    changeIndex(val){
      val.isIndex = !val.isIndex
      var list=[]
      var selef=this.selectfileds
      if(selef&&selef.length>0){
        for(var i=0;i<selef.length;i++){
          var metaName=selef[i].metaName
          if(metaName!=val.metaName){
            list.push(selef[i])
          }
        }
      }
      if(val.isIndex){
        list.push(val)
      }
      this.selectfileds=list
    },
    changeParticiple(val){
      val.isParticiple = !val.isParticiple
      var list=[]
      var selep=this.selectparticiples
      if(selep&&selep.length>0){
        for(var i=0;i<selep.length;i++){
          var metaName=selep[i].metaName
          if(metaName!=val.metaName){
            list.push(selep[i])
          }
        }
      }
      if(val.isParticiple){
        list.push(val)
      }
      this.selectparticiples=list
    },
    handleSelectionChange(data){
      this.selectedList=data
    },
    // handleSelectionChange1(val){
    //   this.selectfileds=val
    // },
    backToPersonal(){
      this.$emit('backPersonal',true)
    },
    adddDialog(){
      this.opstatus='add'
      this.selectfileds=[]
      this.tableDataAdd=[]
      this.dialogVisible=true
      this.selectparticiples=[]
      this.tableRadio=''
      this.shapefield=''
    },
    editDialog(index,row){
      this.opstatus='edit'
      this.editindex=index
      this.selectfileds=[]
      this.selectparticiples=[]
      var data=row
      var selectfield=[]
      var selectpatic=[]//分词
      var label=''
      for (var f in data) {
        if(f!='tab'&&f!='tabshow'&&f!='label'){
          var str=data[f].split(":")
          selectfield.push(str[0])
          if(str[2]&&str[2]=='分词')selectpatic.push(str[0]);
        }
      }
      label=data['label']
      this.tablename= {'name':data['tabshow'],'value':data['tab']}
      this.getFiledListNew(data.tab,label,selectfield,selectpatic)
      this.dialogVisible=true
    },
    handleAddrow(){
      var rep=false
      if(this.opstatus=='add'){
        var that=this
        var tabname=this.tablename['value']
        var r=that.tableData.forEach(function (itemtd, indextd) {
              if (tabname == itemtd.tab) {
                that.$message({message:'该表已经存在！',type:'fail'})
                rep=true
                return false
              }
        })
      }
      if(this.tableRadio){
        if(!rep){
          var tabo={}
          tabo['tabshow']=this.tablename['name']
          tabo['tab']=this.tablename['value']
          // row.push(str)
          var n=0
          var selfs=this.selectfileds
          var selps=this.selectparticiples
          var fielddt=this.fielddata
          for (var i in selfs) {
            var field = selfs[i]
            n=n+1
            var str=field.metaName+':'+field.datatype
            for(var j in selps){
              var selp=selps[j]
              if(selp.metaName==field.metaName){
                str=str+':分词'//分词
              }
            }
            tabo['file'+n]=str
            if(field.metaName==this.tableRadio.metaName) tabo['label']=field.metaName//名字
          }
          n=n+1
          tabo['file'+n]=this.spectialFieldName+":geometry"//shape字段
          if(this.opstatus=='edit'){this.tableData.splice(this.editindex, 1)}
          this.tableData.push(tabo)
        }
        this.dialogVisible = false
      }else{
        that.$message({message:'请选择名称字段！',type:'fail'});
      }
      
    },
    // 批量清除
    handleDelete (index) {
      this.tableData.splice(index, 1)
      // 清除选中状态
      //this.$refs.tableData.clearSelection()
    },
    createIndex(){
      if(this.form.name){
        var json={}
        json['id']=this.form.id
        json['indexLogicname']=this.form.name
        json['indexExplain']=this.form.remark
        json['createUser']=this.loginusername
        json['ableList']=[]
        json['indexList']=[]
        var tabdata=this.tableData
        if(tabdata&&tabdata.length>0){
            var tablejson=[]        
            for(var i in tabdata){
              var row=tabdata[i]
              var tablename=''
              var logicname=''
              var fields=[]
              var label=''
              for(var j in row){            
                if(j=='tab')tablename=row.tab
                else if(j=='tabshow')logicname=row.tabshow
                else if(j=='label')label=row.label
                else{
                  var fieldtype=row[j]
                  var fieldsstr=fieldtype.split(":")
                  var field=fieldsstr[0]
                  var ftype=fieldsstr[1]
                  var o={field:field,fieldType:ftype,tableName:tablename,tableLogicname:logicname,remark:label}
                  o['field']=field
                  o['fieldType']=ftype
                  o['tableName']=tablename
                  o['tableLogicname']=logicname
                  o['remark']=label
                  if(fieldsstr[2]&&fieldsstr[2]=='分词') o['isParticiples']='1'
                  else o['isParticiples']='0'
                  fields.push(o)
                }
              }
              for(var j in fields){
                var f=fields[j]
                if(f['field']==label){
                  f['remark']='label'
                  fields[j]=f
                }
              }
              var o={tableName:tablename,tableLogicname:logicname,indexInfoList:[]}
              o.indexInfoList=fields
              tablejson.push(o)
            }
            json.tableList=tablejson
            var saveLoading = Loading.service({
              target:'#dialog3',
              lock:true,
              text: '正在保存',
              // background: 'rgba(0, 0, 0, 0.7)'
            });
            // console.log(this.form.id)
            if(this.form.id){
              return new Promise((resolve, reject) => {
              request({url:'/portal/myindex/indexEdit', method:'post',data:json ,timeout: 1000 * 60 * 1})
              .then(response => { 
                  saveLoading.close();
                  // this.$message({message:'保存成功',type:'success'});
                  // 隐藏新增/修改页面
                  this.backToPersonal();
                  resolve()
                }).then(()=> {
                  if(this.form.id){
                    var createLoading = Loading.service({
                      target:'#dialog3',
                      lock:true,
                      text: '正在ES中重建索引',
                      // background: 'rgba(0, 0, 0, 0.7)'
                    });
                    return new Promise((resolve, reject) => {
                      request({url:'/portal/myindex/editESSpatialIndex', method:'post',params:{'indexId':this.form.id},timeout: 1000 * 60 * 30})
                      .then(response => { 
                          createLoading.close();
                          this.backToPersonal();
                        }).catch(error => {
                          createLoading.close();
                          reject(error)
                        })
                    })
                  }
                }).catch(error => {
                  saveLoading.close();
                  reject(error)
                })
              })
            }else{
              return new Promise((resolve, reject) => {
              request({url:'/portal/myindex/indexAdd', method:'post',data:json ,timeout: 1000 * 60 * 1})
              .then(response => { 
                  saveLoading.close();
                  this.form.id=response.data.data
                  // this.$message({message:'保存成功',type:'success'});
                  // 隐藏新增/修改页面
                  // this.backToPersonal();
                  // resolve()
                }).then(()=> {
                  if(this.form.id){
                    var createLoading = Loading.service({
                      target:'#dialog3',
                      lock:true,
                      text: '正在ES中创建索引',
                      // background: 'rgba(0, 0, 0, 0.7)'
                    });
                    return new Promise((resolve, reject) => {
                      request({url:'/portal/myindex/createESSpatialIndex', method:'post',params:{'indexId':this.form.id},timeout: 1000 * 60 * 30})
                      .then(response => { 
                          createLoading.close();
                          this.backToPersonal();
                        }).catch(error => {
                          createLoading.close();
                          reject(error)
                        })
                    })
                  }
                }).catch(error => {
                  saveLoading.close();
                  reject(error)
                })
              })
          }
        }else{
            this.$message({message:'请添加表和字段！',type:'fail'})
        }
      }else{
        this.$message({message:'索引名不能为空！',type:'fail'});
      }
      
    },
    getTableList() {
       return new Promise((resolve, reject) => {
          request({url:'/portal/myindex/SelectTablename', method:'post',params:{'username':this.loginusername}})
          .then(response => { 
            //console.log(response.data);
              let list = response.data
              this.tables= list.data
              var str=''
              for (var i in this.tables) {
                var showTableName = this.tables[i].showTableName
                var itableName = this.tables[i].itableName
                str='{"name":"'+showTableName+'","value":"'+itableName+'","ifActive":false}'
                var o=JSON.parse(str)
                this.dataListUls.push(o)
              }
              // resolve(list)
          }).catch(error => {
            reject(error)
           
          })
        })
    },
    changeTableNames(event){
      //  this.getFiledList(event,this.loginusername)
      this.getFiledListNew(event)
    },
    getFiledListNew(tabname,label,selectlist,selectparticiples) {
       return new Promise((resolve, reject) => {
          request({url:'/portal/myindex/getFieldAndExampleData', method:'post',params:{'name':tabname,'username':this.loginusername}})
          .then(response => { 
            console.log(response);
            this.tableDataAdd=[]
            let json = response.data.data
            var b=false
            for (var val in json) {
              var data=val.split(":")
              var metaname=data[0].toLowerCase()
              var datatype=data[1]
              var remark=''
              if(data[2])remark=data[2]
              var fielddata={}
              fielddata['metaName']=metaname
              fielddata['datatype']=datatype
              if(remark=='label')fielddata['isGray']=true
              else fielddata['isGray']=false
              fielddata['isIndex']=false
              fielddata['isParticiple']=false
              var fieldO=json[val]
              if(metaname!='shape'){
                for(var i=0;i<fieldO.length;i++){
                  if(fieldO[i].length>8)fielddata['data'+i]=fieldO[i].substring(0,8)+' ...'
                  else if(fieldO[i]=='')fielddata['data'+i]='[无数据]'
                  else fielddata['data'+i]=fieldO[i]
                  fielddata['dataAll'+i]=fieldO[i]
                }
                this.tableDataAdd.push(fielddata)
              }else{
                if(fieldO[0]){
                  this.spectialFieldName=metaname
                  this.spectialField=fieldO[0]
                }
              }
            }
            // resolve(list)
          }).then(()=>{
            this.tableDataAdd.forEach((v,i) => {
              if(label == v.metaName){
                v.isGray = true
                this.tableRadio=v
              }else{
                v.isGray = false//!v.isGray
              }
            })
            if(selectlist&&selectlist.length>0){             
              for (var i in selectlist) {
                var sel = selectlist[i]
                for(var j in this.tableDataAdd){
                  var tadate=this.tableDataAdd[j].metaName
                  if(sel==tadate){
                    this.tableDataAdd[j].isIndex=true
                    this.selectfileds.push(this.tableDataAdd[j])
                  }
                }
              }
            }
            if(selectparticiples&&selectparticiples.length>0){              
              for (var i in selectparticiples) {
                var sel = selectparticiples[i]
                for(var j in this.tableDataAdd){
                  var tadate=this.tableDataAdd[j].metaName
                  if(sel==tadate){
                    this.tableDataAdd[j].isParticiple=true
                    this.selectparticiples.push(this.tableDataAdd[j])
                  }
                }
              }
            }
          }).catch(error => {
            reject(error)
          })
        })
    },
    //选择数据
    chooseData(val){
      this.dataListUls.forEach((v,i) => {
        if(val == i){
          v.ifActive = true;
          this.tablename= {'name':v.name,'value':v.value}
          this.getFiledListNew(v.value)
        }else{
          v.ifActive = false;
        }
      })
    },
    getTableData(indexid) {
       return new Promise((resolve, reject) => {
          request({url:'/portal/myindex/indexShow', method:'post',params:{'indexId':indexid,'username':'admin'}})
          .then(response => { 
            //console.log(response.data);
              let jsonstr = response.data.data
              var o=JSON.parse(jsonstr)
              this.form.name=o['indexLogicname']
              this.form.remark=o['indexExplain']
              // this.form.id='"'+o['id']+'"'
              this.tableData=o['tableList']
          }).catch(error => {
            reject(error)
          })
        })
    }
     // ,getFiledList(tabname,selectlist) {
    //    return new Promise((resolve, reject) => {
    //       request({url:'/portal/myindex/SelectFiled', method:'post',params:{'name':tabname,'username':this.loginusername}})
    //       .then(response => { 
    //         console.log(response);
    //         this.tableDataAdd=[]
    //           let list = response.data
    //            this.fileds= list.data
    //            //metaName"dataType"columnRemark"length"shapeColumnFlag"shapeType"remark
    //           var str=''
    //           for (var i in this.fileds) {
    //             var metaName = this.fileds[i].metaName;
    //             var dataType = this.fileds[i].dataType;
    //             var columnRemark = this.fileds[i].columnRemark;
    //             var length = this.fileds[i].length;
    //             var shapeColumnFlag = this.fileds[i].shapeColumnFlag;
    //             var shapeType = this.fileds[i].shapeType;
    //             var remark = this.fileds[i].remark;
    //             var isGray = false;
    //             if(shapeColumnFlag=='1')shapeColumnFlag='是' 
    //             else shapeColumnFlag='否'
    //             str='{"metaName":"'+metaName+'","dataType":"'+dataType+'","columnRemark":"'+columnRemark+'","length":"'+length+'","shapeColumnFlag":"'+shapeColumnFlag+'","shapeType":"'+shapeType+'","remark":"'+remark+ '","isGray":"' + isGray +'"}'
    //             var o=JSON.parse(str)
    //             this.tableDataAdd.push(o)
    //           }
    //           resolve(list)
    //       }).then(()=>{
    //         if(selectlist&&selectlist.length>0){
    //           for (var i in selectlist) {
    //             var sel = selectlist[i]
    //             for(var j in this.tableDataAdd){
    //               var tadate=this.tableDataAdd[j].metaName
    //               if(sel==tadate){
    //                 this.$refs.multipleTable.toggleRowSelection(this.tableDataAdd[j],true)
    //               }
    //             }
    //           }
    //         }
    //       }).catch(error => {
    //         reject(error)
           
    //       })
    //     })
    // },
  }
}
</script>

<style scoped>
.contentBox{width:100%;padding:20px;border-radius:5px;box-shadow:0 0 30px #dae5f0;text-align:left;}
.contentBox .title{border-left:2px solid #4da1ff;text-indent:10px;color:#4da1ff}
.line{height:1px;margin:15px 0;border-bottom:1px solid #eee;}
.tableTitle{margin:5px 0 15px;color:#4da1ff}
.tableTitle img{vertical-align:middle;width:14px;}
.btnBox{margin:10px 0;}
.bottomBtnBox{margin-top:20px;text-align:right}
.contentBox >>> .el-table th>.cell{text-align:center}
.contentBox >>> .el-table__body tr td:first-child{background:#fff!important;}
.contentBox >>> .el-table__body tr:first-child td{border-top:0!important;}
.contentBox >>> .el-table th{background:#fafafa}
.dataListUl{float:left;width:18%;height:500px;overflow:auto;padding:0;background:#fff;box-shadow:5px 0 5px #eee;}
.dataListTitle,.dataBoxTitle{margin:20px 0 14px;text-align:center;}
.dataListTitle img,.dataBoxTitle img{width:12px;vertical-align:-2px;margin-right:5px;}
.dataBoxTitle{text-align:left}
.dataListUl li{cursor:pointer;padding:15px 0;text-align:center;}
.dataListUl li:hover{border-right:2px solid #4da1ff;background:#e8f5fd;color:#4da1ff}
.dataListUl .liActive{border-right:2px solid #4da1ff;background:#e8f5fd;color:#4da1ff}

.dataListBox p{font-size:12px;color:#526281}
.dataListBox{float:right;width:80%;max-height:500px;overflow:auto;}
.indLists{padding-bottom:10px;}
.indLists h4{height:30px;line-height:30px;background:#e1f0ff;color:#4da1ff;text-indent:14px;border-radius:5px 5px 0 0}
.indLists p{height:28px;line-height:28px;text-indent:14px;}
.dataListBox .indLists>li,.specilBox{position:relative;float:left;width:130px;height:190px;margin-right:20px;margin-top:20px;border-radius:5px;background:#fff;box-shadow:0 0 10px #eee;}
.specilBox h4{background:#d0f3f3;color:#14c2c3}
.iconBtnBox{position:absolute;left:0;bottom:0;display:flex;width:100%;height:24px;}
.iconFlex{cursor:pointer;flex:1;text-align:center;height:14px;line-height:14px;border-right:1px solid #ccc;color:#ccc}
.iconBtnBox .iconFlex:last-child{border:0;}
.iconFlex img{width:14px;}

.contentBox >>> .el-dialog__title{border-left:2px solid #4da1ff;background:transparent!important;text-indent:15px!important;}
.contentBox >>> .el-dialog__footer{position:relative;border:0!important;box-shadow:0 -3px 5px #eee;}
.contentBox >>> .el-dialog__header{display:none}
.contentBox >>> .el-dialog__body{padding:0!important;background:#f6f7fb}
#diaRecreate >>> .el-dialog__footer{box-shadow:none;}
</style>
